import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonConfigurationClass;
function JsonConfiguration() {
  if (JsonConfigurationClass === VOID) {
    class $ {
      constructor(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy, decodeEnumsCaseInsensitive, allowTrailingComma, allowComments, classDiscriminatorMode, exceptionsWithDebugInfo) {
        encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
        ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
        isLenient = isLenient === VOID ? false : isLenient;
        allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
        prettyPrint = prettyPrint === VOID ? false : prettyPrint;
        explicitNulls = explicitNulls === VOID ? true : explicitNulls;
        prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
        coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
        useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
        classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
        allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
        useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
        namingStrategy = namingStrategy === VOID ? null : namingStrategy;
        decodeEnumsCaseInsensitive = decodeEnumsCaseInsensitive === VOID ? false : decodeEnumsCaseInsensitive;
        allowTrailingComma = allowTrailingComma === VOID ? false : allowTrailingComma;
        allowComments = allowComments === VOID ? false : allowComments;
        classDiscriminatorMode = classDiscriminatorMode === VOID ? ClassDiscriminatorMode_POLYMORPHIC_getInstance() : classDiscriminatorMode;
        exceptionsWithDebugInfo = exceptionsWithDebugInfo === VOID ? true : exceptionsWithDebugInfo;
        this.x2n_1 = encodeDefaults;
        this.y2n_1 = ignoreUnknownKeys;
        this.z2n_1 = isLenient;
        this.a2o_1 = allowStructuredMapKeys;
        this.b2o_1 = prettyPrint;
        this.c2o_1 = explicitNulls;
        this.d2o_1 = prettyPrintIndent;
        this.e2o_1 = coerceInputValues;
        this.f2o_1 = useArrayPolymorphism;
        this.g2o_1 = classDiscriminator;
        this.h2o_1 = allowSpecialFloatingPointValues;
        this.i2o_1 = useAlternativeNames;
        this.j2o_1 = namingStrategy;
        this.k2o_1 = decodeEnumsCaseInsensitive;
        this.l2o_1 = allowTrailingComma;
        this.m2o_1 = allowComments;
        this.n2o_1 = classDiscriminatorMode;
        this.o2o_1 = exceptionsWithDebugInfo;
      }
      toString() {
        return 'JsonConfiguration(encodeDefaults=' + this.x2n_1 + ', ignoreUnknownKeys=' + this.y2n_1 + ', isLenient=' + this.z2n_1 + ', ' + ('allowStructuredMapKeys=' + this.a2o_1 + ', prettyPrint=' + this.b2o_1 + ', explicitNulls=' + this.c2o_1 + ', ') + ("prettyPrintIndent='" + this.d2o_1 + "', coerceInputValues=" + this.e2o_1 + ', useArrayPolymorphism=' + this.f2o_1 + ', ') + ("classDiscriminator='" + this.g2o_1 + "', allowSpecialFloatingPointValues=" + this.h2o_1 + ', ') + ('useAlternativeNames=' + this.i2o_1 + ', namingStrategy=' + toString(this.j2o_1) + ', decodeEnumsCaseInsensitive=' + this.k2o_1 + ', ') + ('allowTrailingComma=' + this.l2o_1 + ', allowComments=' + this.m2o_1 + ', classDiscriminatorMode=' + this.n2o_1.toString() + ', exceptionsWithDebugInfo=' + this.o2o_1 + ')');
      }
    }
    initMetadataForClass($, 'JsonConfiguration');
    JsonConfigurationClass = $;
  }
  return JsonConfigurationClass;
}
var ClassDiscriminatorMode_NONE_instance;
var ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
var ClassDiscriminatorMode_POLYMORPHIC_instance;
var ClassDiscriminatorMode_entriesInitialized;
function ClassDiscriminatorMode_initEntries() {
  if (ClassDiscriminatorMode_entriesInitialized)
    return Unit_instance;
  ClassDiscriminatorMode_entriesInitialized = true;
  ClassDiscriminatorMode_NONE_instance = new (ClassDiscriminatorMode())('NONE', 0);
  ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance = new (ClassDiscriminatorMode())('ALL_JSON_OBJECTS', 1);
  ClassDiscriminatorMode_POLYMORPHIC_instance = new (ClassDiscriminatorMode())('POLYMORPHIC', 2);
}
var ClassDiscriminatorModeClass;
function ClassDiscriminatorMode() {
  if (ClassDiscriminatorModeClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'ClassDiscriminatorMode');
    ClassDiscriminatorModeClass = $;
  }
  return ClassDiscriminatorModeClass;
}
function ClassDiscriminatorMode_NONE_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_NONE_instance;
}
function ClassDiscriminatorMode_ALL_JSON_OBJECTS_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
}
function ClassDiscriminatorMode_POLYMORPHIC_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_POLYMORPHIC_instance;
}
//region block: exports
export {
  ClassDiscriminatorMode_ALL_JSON_OBJECTS_getInstance as ClassDiscriminatorMode_ALL_JSON_OBJECTS_getInstance2svuvlggsd3b,
  ClassDiscriminatorMode_NONE_getInstance as ClassDiscriminatorMode_NONE_getInstance39dg6hx0yqfbs,
  ClassDiscriminatorMode_POLYMORPHIC_getInstance as ClassDiscriminatorMode_POLYMORPHIC_getInstancefnov534wisbx,
  JsonConfiguration as JsonConfiguration2bv2x41u8reet,
};
//endregion

//# sourceMappingURL=JsonConfiguration.mjs.map
